//@flow
import React from 'react';
import classnames from 'classnames';
import { Checkbox, CheckboxTypes } from 'common/components/core/checkbox';
import _ from 'lodash';
import { themr } from 'react-css-themr';
import theme from './WeekSlotsSelector.scss';
import { DayOfWeekType } from 'common/enums/DateTimeEnums';
import { translate } from 'react-i18next';
import { dashboardColors } from 'common/enums/ColorEnum';

const weekSlotsSelectorFactory = WeekSlot => {
    class WeekSlotsSelector extends React.PureComponent {
        onSelectAllToggle = () => {
            const { selectedDays, onToggleSelection } = this.props;
            const allDays = Object.values(DayOfWeekType);
            if (selectedDays.length === allDays.length) {
                onToggleSelection && onToggleSelection([]);
                return;
            }
            onToggleSelection && onToggleSelection(allDays);
            allDays.forEach(dayOfWeek => this.addSlotToDayIfEmpty(dayOfWeek));
        };

        handleToggleSelection = (value, event) => {
            const dayOfWeek = event.target.id;
            const { selectedDays, onToggleSelection } = this.props;
            let updatedSelection = null;
            if (selectedDays.indexOf(dayOfWeek) >= 0) {
                updatedSelection = _.without(selectedDays, dayOfWeek);
            } else {
                updatedSelection = [...selectedDays, dayOfWeek];
                // On Selecting, if no slots add a slot
                this.addSlotToDayIfEmpty(dayOfWeek);
            }
            onToggleSelection && onToggleSelection(updatedSelection);
        };

        addSlotToDayIfEmpty = dayOfWeek => {
            const { timeSlots, onAddSlot, getIsTimeSlotEmpty } = this.props;
            const targetTimeSlot = timeSlots.find(
                timeSlot => timeSlot.dayOfWeek === dayOfWeek
            );
            if (!targetTimeSlot) {
                throw new Error(
                    `Time slot not found for dayOfWeek: ${dayOfWeek}`
                );
            }
            if (getIsTimeSlotEmpty && getIsTimeSlotEmpty(targetTimeSlot)) {
                onAddSlot(dayOfWeek);
            }
        };

        markAsSelected = dayOfWeek => {
            const { selectedDays, onToggleSelection } = this.props;
            if (selectedDays.indexOf(dayOfWeek) >= 0) {
                // Its already selected!
                return;
            }
            const updatedSelection = [...selectedDays, dayOfWeek];
            onToggleSelection && onToggleSelection(updatedSelection);
        };

        markAsUnselected = dayOfWeek => {
            const { selectedDays, onToggleSelection } = this.props;
            if (selectedDays.indexOf(dayOfWeek) < 0) {
                // Its already not selected!
                return;
            }
            const updatedSelection = _.without(selectedDays, dayOfWeek);
            onToggleSelection && onToggleSelection(updatedSelection);
        };

        onDelete = ({ slotFor, index }) => {
            const {
                timeSlots,
                onDelete,
                getShouldUncheckOnRemove
            } = this.props;
            const targetTimeslot = timeSlots.find(
                timeSlot => timeSlot.dayOfWeek === slotFor
            );
            if (!targetTimeslot) {
                throw new Error(
                    `Target time slot not found for day: ${slotFor}`
                );
            }
            if (
                getShouldUncheckOnRemove &&
                getShouldUncheckOnRemove(targetTimeslot)
            ) {
                this.markAsUnselected(slotFor);
            }
            onDelete({ slotFor, index });
        };

        render() {
            const {
                timeSlots,
                selectedDays,
                onChange,
                onCopyToAllClick,
                onAddSlot,
                theme,
                t,
                ...others
            } = this.props;
            const hasSelectedAll =
                Object.values(DayOfWeekType).length === selectedDays.length;
            return (
                <div className={theme.slotOptionsWrap}>
                    <Checkbox
                        className={classnames(
                            theme.selectAll,
                            theme.selection,
                            theme.checkbox
                        )}
                        theme={theme}
                        checked={hasSelectedAll}
                        checkboxType={CheckboxTypes.Solid}
                        onChange={this.onSelectAllToggle}
                        label={t('slotSelector.selectAll')}
                        smallCheckbox
                        checkboxColor={dashboardColors.darkSkyBlue.name}
                    />

                    {timeSlots.map(timeSlot => {
                        return (
                            <WeekSlot
                                {...others}
                                key={timeSlot.dayOfWeek}
                                timeSlot={timeSlot}
                                selectedDays={selectedDays}
                                onChange={onChange}
                                onCopyToAllClick={onCopyToAllClick}
                                onDelete={this.onDelete}
                                onAddSlotClick={onAddSlot}
                                t={t}
                                theme={theme}
                                onToggleDaySelection={
                                    this.handleToggleSelection
                                }
                            />
                        );
                    })}
                </div>
            );
        }
    }
    return translate('entityManagement')(
        themr('WeekSlotsSelector', theme)(WeekSlotsSelector)
    );
};

export default weekSlotsSelectorFactory;
export { weekSlotsSelectorFactory };
